/// <amd-module name="Dashboards/CommonConfig/NameField" />
import * as Resources from "Dashboards/CommonConfig/Resources";
import * as React from "react";
import { IVssComponentContext, IVssComponentProperties, VssComponent } from "VSS/Platform/Layout";
import { TextField } from "VSSUI/TextField";
import { InlineError } from "./InlineError";

export interface NameFieldProps extends IVssComponentProperties {
    /** (Optional, default == true) Describes if name property can be configured for this config.  Field will hide itself if it is not configurable.*/
    isNameConfigurable?: boolean;

    /** Current value of the name property */
    value: string;

    /** Callback to receive updates for name property.  */
    onChange: (value: string) => void;
}

interface NameFieldState {
    showErrors: boolean;
}

/**
 *  A Name "Title" input factored for reuse with Widget Confuration experiences and legacy Widget Host.
 * */
export class NameField extends VssComponent<NameFieldProps, NameFieldState> {
    constructor(props: NameFieldProps, context: IVssComponentContext) {
        super(props, context);

        this.state = {
            showErrors: false
        };
    }

    public shouldComponentUpdate(newProps: NameFieldProps, newState: NameFieldState): boolean {
        // Only update when text is changing from existing state(to avoid cursor position loss after edit events), or when configurability is shifting.
        return (
            newProps.value !== this.props.value ||
            newProps.isNameConfigurable !== this.props.isNameConfigurable ||
            newProps.onChange !== this.props.onChange
        );
    }

    public render(): JSX.Element | null {
        const showError = this.state.showErrors && !isNameValid(this.props.value);
        return (
            (this.props.isNameConfigurable !== false && (
                <div>
                    <TextField
                        className="config-name-field"
                        label={Resources.TitleControlLabel}
                        onChange={this.onChange}
                        onFocus={this.onFocus}
                        value={this.props.value}
                        ariaInvalid={showError}
                        required={true}
                    />
                    {<InlineError message={showError ? Resources.TitleControl_ValueOutOfRange : undefined} />}
                </div>
            )) ||
            null
        );
    }

    private onChange = (_event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>, value: string): void => {
        this.props.onChange(value);
    };

    private onFocus = (): void => {
        this.setState({ showErrors: true });
    };
}

export function isNameValid(name: string): boolean {
    return name != null && name.length > 0 && name.length < 256;
}
